import React, { FC, useState } from "react";

import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";

import FeatherIcon from "feather-icons-react";

import { CustomerProfileResponse } from "./CustomerProfile.constants";
import { UseMutateFunction } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../shared/actions/Authentication.actions";
import { Permissions } from "../../shared/models/Types";
import CustomerMaintanenceUpdateModal from "./CustomerMaintanenceUpdateModal";
import CustomerWarrantyUpdateModal from "./CustomerWarrantyUpdateModal";

export interface ProfileTab1Props {
  toggleHistory: () => void;
  toggleMaintanence: () => void;
  data?: CustomerProfileResponse;
  mutate: UseMutateFunction<
    CustomerProfileResponse,
    AxiosError<any>,
    any,
    unknown
  >;
}

const ProfileTab1: FC<ProfileTab1Props> = ({
  toggleHistory,
  toggleMaintanence,
  data,
  mutate,
}) => {
  const permissionList = useRecoilValue(permissionsSelector);

  const [isMaintanenceUpdateModalOpen, setIsMaintanenceUpdateModalOpen] =
    useState<boolean>(false);
  const [isWarrantyUpdateModalOpen, setWarrantyUpdateIsModalOpen] =
    useState<boolean>(false);

  const toggleMaintanenceUpdate = () => {
    setIsMaintanenceUpdateModalOpen(!isMaintanenceUpdateModalOpen);
  };

  const toggleWarriantyUpdate = () => {
    setWarrantyUpdateIsModalOpen(!isWarrantyUpdateModalOpen);
  };

  const calculateManyDays = (nextMaintenance = "") => {
    const maintenanceDate = new Date();
    const nextMaintenanceDate = new Date(nextMaintenance);

    const maintenanceDateMiliseconds = maintenanceDate.getTime();
    const nextMaintenanceMiliseconds = nextMaintenanceDate.getTime();

    const dayDifference = Math.abs(
      nextMaintenanceMiliseconds - maintenanceDateMiliseconds
    );

    const remainingDays = Math.ceil(dayDifference / (1000 * 3600 * 24));

    return remainingDays < 0 ? "Kalan Gün Geçti" : remainingDays;
  };

  const formatDate = (dateString: string) => {
    return dateString
      ? new Date(dateString).toISOString().split("T")[0]
      : "Bilgi Yok";
  };

  const viewMaintenancePermission = permissionList[Permissions.ViewMaintenance];
  const updateMaintenancePermission =
    permissionList[Permissions.ChangeMaintenance];
  const viewMaintenanceMaterialPermission =
    permissionList[Permissions.ViewMaintenancematerialoperation];

  return (
    <React.Fragment>
      <Card>
        <CardHeader>
          <div className="d-flex">
            <div className="flex-grow-1">
              <h5 className="card-title mb-0">Cihaz Bilgileri</h5>
            </div>
            <div
              onClick={toggleMaintanenceUpdate}
              className="flex-shrink-0 pointer"
            >
              {updateMaintenancePermission && <FeatherIcon icon="edit" />}
            </div>
          </div>
        </CardHeader>
        <CardBody>
          <div className="pb-3">
            <Row>
              <Col>
                <div>
                  <h5 className="font-size-15">Montaj Tarihi:</h5>
                </div>
              </Col>

              <Col>
                <div className="text-muted">
                  <p className="mb-2">
                    {data ? (
                      formatDate(
                        data?.customer_devices[0]?.date_of_setup !== null
                          ? data?.customer_devices[0]?.date_of_setup
                              .toString()
                              .split("T")[0]
                          : ""
                      )
                    ) : (
                      <span className="placeholder col-3"></span>
                    )}
                  </p>
                </div>
              </Col>
            </Row>
          </div>

          <div className="pb-3">
            <Row>
              <Col>
                <div>
                  <h5 className="font-size-15">Cihaz Modeli:</h5>
                </div>
              </Col>

              <Col>
                <div className="text-muted">
                  <p className="mb-2">
                    {data?.customer_devices.length &&
                    data?.customer_devices[0]?.device?.name ? (
                      data?.customer_devices[0]?.device?.name
                    ) : (
                      <span className="placeholder col-2"></span>
                    )}
                  </p>
                </div>
              </Col>
            </Row>
          </div>

          <div className="pb-3">
            <Row>
              <Col>
                <div>
                  <h5 className="font-size-15">Sistem:</h5>
                </div>
              </Col>

              <Col>
                <div className="text-muted">
                  <p className="mb-2">
                    {data ? (
                      data?.customer_devices[0]?.device?.system === "open" ? (
                        "Açık Sistem"
                      ) : (
                        "Kapalı Sistem"
                      )
                    ) : (
                      <span className="placeholder col-2"></span>
                    )}
                  </p>
                </div>
              </Col>
            </Row>
          </div>

          <div className="pb-3">
            <Row>
              <Col>
                <div>
                  <h5 className="font-size-15">Yapılan İşlem:</h5>
                </div>
              </Col>

              <Col>
                <div className="text-muted">
                  <p className="mb-2">
                    {data?.customer_devices.length ? (
                      data?.customer_devices[data?.customer_devices.length - 1]
                        ?.first_setup ? (
                        "Montaj"
                      ) : (
                        "Bakım"
                      )
                    ) : (
                      <span className="placeholder col-4"></span>
                    )}
                  </p>
                </div>
              </Col>
            </Row>
          </div>

          <div className="pb-3">
            <Row>
              <Col>
                <div>
                  <h5 className="font-size-15">Not:</h5>
                </div>
              </Col>

              <Col>
                <div className="text-muted">
                  <p className="mb-2">
                    {data ? (
                      data?.maintenances[data?.maintenances.length - 1]?.note
                    ) : (
                      <span className="placeholder col-5"></span>
                    )}
                  </p>
                </div>
              </Col>
            </Row>
          </div>

          <div className="pb-3">
            <Row>
              <Col>
                <div>
                  <h5 className="font-size-15">Bakım Tarihi:</h5>
                </div>
              </Col>

              <Col>
                <div className="text-muted">
                  <p className="mb-2">
                    {data?.maintenances.length ? (
                      formatDate(
                        (
                          data?.maintenances[data?.maintenances.length - 1]
                            ?.next_maintenance_date || ""
                        )
                          .toString()
                          .split("T")[0]
                      )
                    ) : (
                      <span className="placeholder col-3"></span>
                    )}
                  </p>
                </div>
              </Col>
            </Row>
          </div>

          <div className="pb-3">
            <Row>
              <Col>
                <div>
                  <h5 className="font-size-15">Kalan Gün:</h5>
                </div>
              </Col>

              <Col>
                <div className="text-muted">
                  <p className="mb-2">
                    {data?.maintenances.length ? (
                      !(
                        data?.maintenances[data?.maintenances.length - 1]
                          ?.remaining_days || " "
                      ).includes(" ") ? (
                        0
                      ) : (
                        (
                          data?.maintenances[data?.maintenances.length - 1]
                            ?.remaining_days || " "
                        ).split(" ")[0]
                      )
                    ) : (
                      <span className="placeholder col-3"></span>
                    )}
                  </p>
                </div>
              </Col>
            </Row>
          </div>

          <div className="d-flex">
            <div className="flex-grow-1"></div>
            <div
              style={{ justifyContent: "space-between" }}
              className="flex-shrink-0"
            >
              {viewMaintenancePermission && (
                <span
                  onClick={() => {
                    toggleHistory();
                  }}
                  className="badge btn btn-success rounded-pill mt-1 font-size-12 p-3  pointer"
                >
                  <i className="mdi mdi-animation-outline noti-icon m-1"></i>
                  Eski Bakımlar
                </span>
              )}

              <span className="m-2"></span>

              {viewMaintenanceMaterialPermission && (
                <span
                  onClick={() => {
                    toggleMaintanence();
                  }}
                  className="badge btn btn-primary rounded-pill font-size-12 p-3 pointer"
                >
                  <i className="mdi mdi-firework noti-icon m-1"></i>
                  Bakım Yap
                </span>
              )}
            </div>
          </div>
        </CardBody>
      </Card>

      <Card>
        <CardHeader>
          <div className="d-flex">
            <div className="flex-grow-1">
              <h5 className="card-title mb-0">Garanti Bilgileri</h5>
            </div>
            <div
              onClick={toggleWarriantyUpdate}
              className="flex-shrink-0 pointer"
            >
              {updateMaintenancePermission && <FeatherIcon icon="edit" />}
            </div>
          </div>
        </CardHeader>
        <CardBody>
          <div className="pb-3">
            <Row>
              <Col>
                <div>
                  <h5 className="font-size-15">Başlangıç Tarihi:</h5>
                </div>
              </Col>

              <Col>
                <div className="text-muted">
                  <p className="mb-2">
                    {data?.customer_devices.length &&
                      data?.customer_devices[0]?.warranty_start &&
                      formatDate(
                        data?.customer_devices[0]?.warranty_start
                          ?.toString()
                          .split("T")[0]
                      )}
                  </p>
                </div>
              </Col>
            </Row>
          </div>

          <div className="pb-3">
            <Row>
              <Col>
                <div>
                  <h5 className="font-size-15">Bitiş Tarihi:</h5>
                </div>
              </Col>

              <Col>
                <div className="text-muted">
                  <p className="mb-2">
                    {data?.customer_devices.length &&
                      data?.customer_devices[0]?.warranty_end &&
                      formatDate(
                        data?.customer_devices[0]?.warranty_end
                          .toString()
                          .split("T")[0]
                      )}
                  </p>
                </div>
              </Col>
            </Row>
          </div>

          <div className="pb-3">
            <Row>
              <Col>
                <div>
                  <h5 className="font-size-15">Kalan Gün:</h5>
                </div>
              </Col>

              <Col>
                <div className="text-muted">
                  <p className="mb-2">
                    {data?.customer_devices[0]?.warranty_end &&
                      data?.customer_devices[0]?.warranty_end &&
                      calculateManyDays(
                        data?.customer_devices[0]?.warranty_end
                          .toString()
                          .split("T")[0]
                      )}
                  </p>
                </div>
              </Col>
            </Row>
          </div>
        </CardBody>
      </Card>

      <Card>
        <CardHeader>
          <div className="flex-grow-1">
            <h5 className="card-title mb-0">Cihaz içindeki malzemeler</h5>
          </div>
        </CardHeader>
        <CardBody>
          <Row>
            <Col xl={12}>
              <ul style={{ padding: "2" }} className="list-unstyled  mb-4">
                {data &&
                  data?.maintenances[0]?.maintenance_materials.map(
                    (maintenance_material) => {
                      return (
                        <li
                          style={{
                            borderBottom: "1px solid #7b8198",
                            paddingBottom: 11,
                          }}
                          key={maintenance_material.device_part.name}
                        >
                          <div className="d-flex align-items-start">
                            <div className="flex-grow-1 overflow-hidden h-2">
                              <h5 className="text-truncate font-size-14 mt-2">
                                {maintenance_material.device_part.name}
                              </h5>
                            </div>
                          </div>
                        </li>
                      );
                    }
                  )}
              </ul>
            </Col>
          </Row>
        </CardBody>
      </Card>

      {isMaintanenceUpdateModalOpen && (
        <CustomerMaintanenceUpdateModal
          isModalOpen={isMaintanenceUpdateModalOpen}
          toggle={toggleMaintanenceUpdate}
          profilData={data}
          mutate={mutate}
        />
      )}

      {isWarrantyUpdateModalOpen && (
        <CustomerWarrantyUpdateModal
          isModalOpen={isWarrantyUpdateModalOpen}
          toggle={toggleWarriantyUpdate}
          profilData={data}
          mutate={mutate}
        />
      )}
    </React.Fragment>
  );
};

export default ProfileTab1;
